import {compose, lifecycle, withState} from 'recompose';
import App from './App';
import {getStudio} from '../service/data';

function componentWillMount() {
  getStudio({})
    .then((response) => {
      this.props.setStudios(response);
      this.props.setIsLoading(false);
    });
}

const enhance = compose(
  withState('studios', 'setStudios', []),
  withState('isLoading', 'setIsLoading', true),
  lifecycle({
    componentWillMount,
  }),
);

export default enhance(App);



// WEBPACK FOOTER //
// src/App/AppContainer.js